module.exports = __webpack_public_path__ + "media/images/banks/vn-acb-b50240d368874b6541231eb73c63e245.png";